import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, GitCompareArrows, Activity } from "lucide-react";
import { api, apiErr } from "../api";
import { FOLLOWUP_GROUPS } from "../fields";
import { PanelPage, Header, PageTitle, FullLoader, prettyDate } from "../ui";
import FollowUpModal from "../components/FollowUpModal";

export default function Compare() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = () => api.get(`/patients/${id}`).then((r) => setP(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!p) return <PanelPage><Header wide /><FullLoader /></PanelPage>;
  const updates = p.updates || [];
  const cols = [{ label: "Primera consulta", date: p.fecha_consulta, data: p, base: true },
    ...updates.map((u, i) => ({ label: `Control ${i + 1}`, date: u.fecha, note: u.nota, data: u }))];

  return (
    <PanelPage>
      <Header wide />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <Link to={`/pacientes/${id}`} className="inline-flex items-center gap-1.5 text-sm pn-sub mb-4"><ArrowLeft size={15} /> Volver a la ficha</Link>
        <PageTitle eyebrow="Evolución del paciente" title={p.nombre} sub={updates.length ? "Las celdas resaltadas cambiaron respecto a la primera consulta." : "Aún no hay seguimientos para comparar."}>
          <button onClick={() => setAdding(true)} className="pn-btn pn-btn-primary"><Activity size={16} /> Nuevo seguimiento</button>
        </PageTitle>
        {FOLLOWUP_GROUPS.map((g) => (
          <section key={g.group} className="mb-7">
            <h2 className="font-bold pn-ink mb-3 flex items-center gap-2"><GitCompareArrows size={17} className="pn-brand" /> {g.group}</h2>
            <div className="pn-card rounded-2xl overflow-x-auto">
              <table className="pn-table">
                <thead><tr><th className="sticky left-0 z-[1] w-48" style={{ background: "var(--card2)" }}>Campo</th>
                  {cols.map((c, i) => <th key={i} className="min-w-[210px]"><span className={c.base ? "pn-accent" : "pn-brand"}>{c.label}</span><div className="text-xs font-normal pn-muted">{prettyDate(c.date)}{c.note ? ` · ${c.note}` : ""}</div></th>)}
                </tr></thead>
                <tbody>{g.items.map(([k, label]) => {
                  const base = String(p[k] || "").trim();
                  return (
                    <tr key={k} className="align-top">
                      <td className="sticky left-0 font-medium pn-sub" style={{ background: "var(--card)" }}>{label}</td>
                      {cols.map((c, i) => {
                        const v = String(c.data[k] || "").trim();
                        const changed = !c.base && v && v !== base;
                        return <td key={i} className="whitespace-pre-wrap pn-ink text-sm" style={changed ? { background: "rgba(217,119,6,.12)" } : undefined}>{v || <span className="pn-muted">—</span>}</td>;
                      })}
                    </tr>
                  );
                })}</tbody>
              </table>
            </div>
          </section>
        ))}
      </main>
      {adding && <FollowUpModal patient={p} onClose={() => setAdding(false)} onSaved={load} />}
    </PanelPage>
  );
}
